import type { TabsTabProps } from '@base-ui/react';

import { Tabs as BaseTabs } from '@base-ui/react';
import { Link, type LinkProps } from 'react-router';

import { clsxs } from '~/styles/utils';

import { Icon, type IconName } from '../Icon/Icon';
import { labelStyle } from './Tabs.css';

type Props = LinkProps &
  Pick<TabsTabProps, 'value' | 'disabled' | 'className'> & {
    icon?: IconName;
  };

export const TabsTabLink = ({ children, className, disabled, icon, value, ...delegated }: Props) => {
  return (
    <BaseTabs.Tab
      className={clsxs(labelStyle, className)}
      disabled={disabled}
      nativeButton={false}
      render={<Link {...delegated} />}
      value={value}
    >
      {icon && <Icon name={icon} size={20} />}

      <span>{children}</span>
    </BaseTabs.Tab>
  );
};
